module.exports = __webpack_public_path__ + "img/procyon.7ad257d0.png";